import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { TileContentModel } from '@/types/B2BcontentServerContract';
import MediaHandler from '@/shared/content/blocks/helpers/MediaHandler.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'CollageTileDefaultLayoutMediaWithLink',
  props: {
    data: null,
    aspectRatio: null
  },
  setup(__props: any) {




return (_ctx: any,_cache: any) => {
  const _component_RouterLinkConditional = _resolveComponent("RouterLinkConditional")!

  return (__props.data.link)
    ? (_openBlock(), _createBlock(_component_RouterLinkConditional, {
        key: 0,
        to: __props.data.link.url,
        target: __props.data.link.target,
        "spa-enabled": __props.data.link.spaLink,
        title: __props.data.link.title,
        class: "w-full h-full overflow-hidden"
      }, {
        default: _withCtx(() => [
          _createVNode(MediaHandler, {
            class: "overflow-image-padding",
            "media-block": __props.data.media,
            "media-aspect-ratio": __props.aspectRatio
          }, null, 8, ["media-block", "media-aspect-ratio"])
        ]),
        _: 1
      }, 8, ["to", "target", "spa-enabled", "title"]))
    : (_openBlock(), _createBlock(MediaHandler, {
        key: 1,
        class: "overflow-image-padding",
        "media-block": __props.data.media,
        "media-aspect-ratio": __props.aspectRatio
      }, null, 8, ["media-block", "media-aspect-ratio"]))
}
}

})